<template>
  <div>
    <div class="row col-5 q-mt-lg q-ml-sm q-mr-sm imprimir">
      <q-select
        dense
        outlined
        class="col-md-2 col-xs"
        :options="options.treinamentoOptions"
        v-model="treinamento"
        option-label="label"
        option-value="value"
      />
    </div>
    <div v-if="!mobile" class="q-pa-sm" id="base-desktop">
      <div class="col-12 container-certificado">
        <div class="row col-12">
          <div style="width: 18%" class="column justify-around top q-pa-md">
            <q-img
              v-if="$store.state.autenticacao.logo.logoImpressao"
              :src="$store.state.autenticacao.logo.logoImpressao"
              crossorigin="*"
            />
            <q-img
              v-else
              crossorigin="*"
              src="../../../../assets/MULTPEX_LOGO.png"
            />
          </div>
        </div>
        <div class="row col-12 justify-center q-mt-md">
          <span class="text-h4 text-bold">{{
            dadosCertificado.titulo_certificado
          }}</span>
        </div>
        <div class="row col-12 justify-center q-mt-lg q-mb-xl">
          <div class="row col-6">
            <span class="texto-certificado text-weight-medium"
              >Certificamos que
              <b>
                <span>{{ funcionarioDados.nome }}&nbsp;</span></b
              >
              participou do
              <b>
                <span>{{ dadosCertificado.nome_treinamento }}&nbsp;</span>
              </b>
              <span>{{ dadosCertificado.descricao_certificado }}&nbsp;</span>
              <span>{{ dadosCertificado.nome_vendor }}</span>
              no dia,
              <span>{{ dataCertificado.data }}</span>
              com carga horária de
              <span>{{ dadosCertificado.carga_horaria }}</span>
              de duração.</span
            >
            <span
              class="row col-12 texto-certificado justify-start text-weight-medium q-mt-md"
              >{{ dataCertificado.dataFormatada }}</span
            >
          </div>
        </div>
        <div
          class="row col-12 justify-around q-gutter-x-md"
          style="margin: 170px 0px 60px 0px"
        >
          <div
            class="col-2 text-weight-bold"
            style="margin-top: 110px"
            v-if="treinamento?.instrutorAssinatura != null"
          >
            <q-img
              v-if="treinamento?.instrutorAssinatura"
              height="80px"
              width="140px"
              fit="contain"
              :src="treinamento?.instrutorAssinatura"
              crossorigin="*"
            />
            <div v-else style="height: 80px"></div>

            <div style="border-top: solid 1px black"></div>
            <div class="row col-12 justify-center q-my-sm">INSTRUTOR</div>
            <div class="row col-12 justify-start q-my-sm">
              <span v-if="treinamento?.instrutor">
                {{ treinamento?.instrutor?.toLocaleUpperCase() }}</span
              >
              <span class="row col-12 justify-start" v-else>
                NOME INSTRUTOR</span
              >
            </div>
            <div class="row col-12 justify-center"></div>
            <div class="row col-12 justify-start">ID:</div>
          </div>
          <div
            class="col-2 text-weight-bold"
            style="margin-top: 110px"
            v-if="funcionarioDados.authContent != null"
          >
            <q-img
              v-if="
                funcionarioDados.authType != null &&
                funcionarioDados.authType != undefined
              "
              height="80px"
              width="140px"
              crossorigin="*"
              fit="contain"
              :src="funcionarioDados.authContent"
            />
            <div v-else style="height: 85px"></div>
            <div style="border-top: solid 1px black"></div>
            <div class="row col-12 justify-center q-my-sm">COLABORADOR</div>
            <div class="row col-12 justify-start q-my-sm">
              {{ funcionarioDados.nome?.toLocaleUpperCase() }}
            </div>
            <div class="row col-12 justify-start">
              ID: {{ funcionarioDados.matricula }}
            </div>
          </div>
          <div
            class="col-2 text-weight-bold"
            style="margin-top: 110px"
            v-if="dadosCertificado?.url_assinatura_responsavel != null"
          >
            <div class="row col-12 justify-center q-mb-xs">
              <q-img
                v-if="dadosCertificado?.url_assinatura_responsavel"
                :src="dadosCertificado?.url_assinatura_responsavel"
                height="80px"
                width="140"
                fit="contain"
                crossorigin="*"
              />
              <div v-else style="height: 80px"></div>
            </div>
            <div style="border-top: solid 1px black"></div>
            <div class="row col-12 justify-center q-my-sm">
              <span>{{
                dadosCertificado.cargo_responsavel?.toLocaleUpperCase()
              }}</span>
            </div>
            <div class="row col-12 justify-start q-my-sm">
              {{ dadosCertificado.nome_responsavel?.toLocaleUpperCase() }}
            </div>
            <div class="row col-12 justify-start">
              <span>ID: {{ dadosCertificado.identificacao_responsavel }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="page-break-after: always"></div>
      <div class="q-mt-sm">
        <div class="container-certificado">
          <div class="row col-12 justify-center q-mt-md">
            <span v-html="dadosCertificado.titulo_conteudo_programatico"></span>
          </div>
          <div class="row col-12 justify-center q-mt-md">
            <span
              class="text-h6 text-weight-medium"
              v-html="dadosCertificado.subtitulo_conteudo_programatico"
            ></span>
          </div>
          <div class="row col-12 justify-center q-mt-md">
            <div class="col-9">
              <span
                v-html="dadosCertificado.descricao_conteudo_programatico"
              ></span>
            </div>
          </div>
          <div class="row col-12 justify-end">
            <div style="width: 18%" class="column justify-around top q-pa-md">
              <q-img
                v-if="$store.state.autenticacao.logo.logoImpressao"
                :src="$store.state.autenticacao.logo.logoImpressao"
                crossorigin="*"
              />
              <q-img
                v-else
                crossorigin="*"
                src="../../../../assets/MULTPEX_LOGO.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="overflow: scroll; width: 100%">
      <div class="q-pa-sm" id="base-mobile">
        <div class="col-12 container-certificado">
          <div class="row col-12">
            <div style="width: 18%" class="column justify-around top q-pa-md">
              <q-img
                v-if="$store.state.autenticacao.logo.logoImpressao"
                :src="$store.state.autenticacao.logo.logoImpressao"
                crossorigin="*"
              />
              <q-img
                v-else
                src="../../../../assets/MULTPEX_LOGO.png"
                crossorigin="*"
              />
            </div>
          </div>
          <div class="row col-12 justify-center q-mt-md">
            <span class="text-h4 text-bold">{{
              dadosCertificado.titulo_certificado
            }}</span>
          </div>
          <div class="row col-12 justify-center q-mt-lg q-mb-xl">
            <div class="row col-6">
              <span class="texto-certificado text-weight-medium"
                >Certificamos que
                <b>
                  <span>{{ funcionarioDados.nome }}&nbsp;</span></b
                >
                participou do
                <b>
                  <span>{{ dadosCertificado.nome_treinamento }}&nbsp;</span>
                </b>
                <span>{{ dadosCertificado.descricao_certificado }}&nbsp;</span>
                <span>{{ dadosCertificado.nome_vendor }}</span>
                no dia,
                <span>{{ dataCertificado.data }}</span>
                com carga horária de
                <span>{{ dadosCertificado.carga_horaria }}</span>
                de duração.</span
              >
              <span
                class="row col-12 texto-certificado justify-start text-weight-medium q-mt-md"
                >{{ dataCertificado.dataFormatada }}</span
              >
            </div>
          </div>
          <div
            class="row col-12 justify-around q-gutter-x-md"
            style="margin: 170px 0px 60px 0px"
          >
            <div
              class="col-2 text-weight-bold"
              style="margin-top: 110px"
              v-if="treinamento?.instrutorAssinatura != null"
            >
              <q-img
                v-if="treinamento?.instrutorAssinatura"
                height="80px"
                width="140px"
                fit="contain"
                :src="treinamento?.instrutorAssinatura"
                crossorigin="*"
              />
              <div v-else style="height: 80px"></div>

              <div style="border-top: solid 1px black"></div>
              <div class="row col-12 justify-center q-my-sm">INSTRUTOR</div>
              <div class="row col-12 justify-start q-my-sm">
                <span v-if="treinamento?.instrutor">
                  {{ treinamento?.instrutor?.toLocaleUpperCase() }}</span
                >
                <span class="row col-12 justify-start" v-else>
                  NOME INSTRUTOR</span
                >
              </div>
              <div class="row col-12 justify-center"></div>
              <div class="row col-12 justify-start">ID:</div>
            </div>
            <div
              class="col-2 text-weight-bold"
              style="margin-top: 110px"
              v-if="
                treinamento?.instrutorAssinatura != funcionarioDados.authType
              "
            >
              <q-img
                v-if="
                  funcionarioDados.authType != null &&
                  funcionarioDados.authType != undefined
                "
                height="80px"
                width="140px"
                fit="contain"
                :src="funcionarioDados.authContent"
                crossorigin="*"
              />
              <div v-else style="height: 85px"></div>
              <div style="border-top: solid 1px black"></div>
              <div class="row col-12 justify-center q-my-sm">COLABORADOR</div>
              <div class="row col-12 justify-start q-my-sm">
                {{ funcionarioDados.nome?.toLocaleUpperCase() }}
              </div>
              <div class="row col-12 justify-start">
                ID: {{ funcionarioDados.matricula }}
              </div>
            </div>
            <div
              class="col-2 text-weight-bold"
              style="margin-top: 110px"
              v-if="dadosCertificado?.url_assinatura_responsavel != null"
            >
              <div class="row col-12 justify-center q-mb-xs">
                <q-img
                  v-if="dadosCertificado?.url_assinatura_responsavel"
                  :src="dadosCertificado?.url_assinatura_responsavel"
                  height="80px"
                  width="140"
                  fit="contain"
                  crossorigin="*"
                />
                <div v-else style="height: 80px"></div>
              </div>
              <div style="border-top: solid 1px black"></div>
              <div class="row col-12 justify-center q-my-sm">
                <span>{{
                  dadosCertificado.cargo_responsavel?.toLocaleUpperCase()
                }}</span>
              </div>
              <div class="row col-12 justify-start q-my-sm">
                {{ dadosCertificado.nome_responsavel?.toLocaleUpperCase() }}
              </div>
              <div class="row col-12 justify-start">
                <span
                  >ID: {{ dadosCertificado.identificacao_responsavel }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div style="page-break-after: always"></div>
        <div class="q-mt-sm">
          <div class="container-certificado">
            <div class="row col-12 justify-center q-mt-md">
              <span
                v-html="dadosCertificado.titulo_conteudo_programatico"
              ></span>
            </div>
            <div class="row col-12 justify-center q-mt-md">
              <span
                class="text-h6 text-weight-medium"
                v-html="dadosCertificado.subtitulo_conteudo_programatico"
              ></span>
            </div>
            <div class="row col-12 justify-center q-mt-md">
              <div class="col-9">
                <span
                  v-html="dadosCertificado.descricao_conteudo_programatico"
                ></span>
              </div>
            </div>
            <div class="row col-12 justify-end">
              <div style="width: 18%" class="column justify-around top q-pa-md">
                <q-img
                  v-if="$store.state.autenticacao.logo.logoImpressao"
                  :src="$store.state.autenticacao.logo.logoImpressao"
                  crossorigin="*"
                />
                <q-img
                  v-else
                  src="../../../../assets/MULTPEX_LOGO.png"
                  crossorigin="*"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const capacitacaoId = route.params.capacitacaoId;
    const funcionarioId = route.params.funcionarioId;
    const treinamento = ref();
    const options = ref({
      treinamentoOptions: [],
    });
    const dadosCertificado = ref([]);
    const dataCertificado = ref({ dataFormatada: "", data: "" });
    const funcionarioDados = ref("");
    const instrutor = ref({
      nome: "",
      instrutorId: "",
      assinatura: "",
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }

    const receberDetalhesCertificado = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        const response = await store.dispatch(
          "treinamento/detalharCapacitacao",
          {
            capacitacao_id: capacitacaoId,
          }
        );
        response.data.treinamentos.forEach((treinamento) => {
          options.value.treinamentoOptions.push({
            label: treinamento.nome,
            value: treinamento.treinamentoId,
            instrutor: treinamento.instrutor,
            instrutorAssinatura: treinamento.instrutor_url_assinatura,
          });
        });
        response.data.funcionarios.forEach((funcionario) => {
          if (funcionario.funcionarioId == funcionarioId) {
            funcionarioDados.value = funcionario;
          }
        });
        treinamento.value = options.value.treinamentoOptions[0];
        gerarData(response.data.dataRealizacao.split("-").reverse().join("/"));
        gerarCertificadoFuncionario();
        if (mobile.value) {
          zoomOut();
        }
        salvarPdf();
      } catch (error) {
        console.log(error);
      }
    };

    const zoomOut = () => {
      const content = document.getElementById("base-mobile");
      content.style.transform = "scale(0.9)";
      content.style.width = `300%`;
      content.style.height = `100%`;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const centerX = (windowWidth - content.clientWidth) / 2;
      const centerY = (windowHeight - content.clientHeight) / 2;

      content.style.transformOrigin = "top left";
      content.style.left = centerX + "px";
      content.style.top = centerY + "px";
    };

    const salvarPdf = async () => {
      quasar.notify({
        message: "Aguarde enquanto o PDF é gerado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      setTimeout(() => {
        let data = document.getElementById(
          mobile.value ? "base-mobile" : "base-desktop"
        );
        var hoje = new Date();
        let dataGerado = `${hoje.getDate()}/${hoje.getMonth()}/${hoje.getFullYear()} ${hoje.getHours()}:${
          hoje.getMinutes() /* < 10 ? "0" + hoje.getMinutes() : hoje.getMinutes()*/
        }:${hoje.getMilliseconds()}`;
        html2canvas(data, {
          useCORS: true,
        }).then((canvas) => {
          var imgWidth = 295;
          var pageHeight = 210;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;

          var heightLeft = imgHeight;
          const imgData = canvas.toDataURL("image/jpeg");

          var doc = new jsPDF("l", "mm", "a4", true);
          var position = 2;
          doc.addImage(
            imgData,
            "JPEG",
            1,
            position,
            imgWidth - 0,
            imgHeight + 0
          );
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              imgData,
              "JPEG",
              1,
              position,
              imgWidth - 0,
              imgHeight + 0
            );
            heightLeft -= pageHeight;
          }
          doc.save(
            `certificado_treinamento_${funcionarioDados.value.nome}_${dataGerado}`
          );
        });
      }, 3000);
    };

    const gerarCertificadoFuncionario = async () => {
      try {
        const response = await store.dispatch(
          "treinamento/gerarCertificadoFuncionario",
          {
            funcionario_id: funcionarioId,
            treinamento_id: treinamento.value.value,
            capacitacao_id: capacitacaoId,
          }
        );
        if (response.data.response == null) {
          return;
        }
        dadosCertificado.value = response.data.response.certificado;
        dataCertificado.value.data =
          response.data.response.dataConfirmacaoCapacitacao
            .split("-")
            .reverse()
            .join("/");
      } catch (error) {
        console.log(error);
      }
    };

    const gerarData = (data) => {
      const mes = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      const dataPartes = data.split("/");
      const dia = parseInt(dataPartes[0], 10);
      const mesIndex = parseInt(dataPartes[1], 10) - 1;
      const year = parseInt(dataPartes[2], 10);

      const monthName = mes[mesIndex];

      dataCertificado.value.dataFormatada = `${dia} de ${monthName} de ${year}`;
    };

    watch(
      () => treinamento.value,
      () => {
        instrutor.value = {
          nome: treinamento.value.instrutor,
          id: treinamento.value.instrutorId,
          assinatura: treinamento.value.assinaturaIntrutor,
        };
        gerarCertificadoFuncionario();
      }
    );

    onMounted(receberDetalhesCertificado);

    return {
      treinamento,
      options,
      capacitacaoId,
      receberDetalhesCertificado,
      funcionarioId,
      gerarCertificadoFuncionario,
      dadosCertificado,
      salvarPdf,
      zoomOut,
      gerarData,
      dataCertificado,
      funcionarioDados,
      instrutor,
      mobile,
    };
  },
};
</script>

<style scoped>
.container-certificado {
  border: solid 5px black;
  border-radius: 2px;
}
.texto-certificado {
  text-align: center;
  text-justify: inter-word;
  font-size: 18px;
}
@media print {
  .imprimir {
    display: none;
  }
}
</style>
